export const validateDate = date => {
  if (!date ||
    (date instanceof Date && !isNaN(date))) {
    return true;
  }

  return false;
}